<template>
    <div>
      <modal name="info-individual" :width="700" :height="'auto'" :clickToClose="false">
        <div class="modal-content modalContent">
          <span class="closebtn" @click="closeModal">&times;</span>
        </div>
        <div class="row p-3">
          <div class="col-md-12">
            <h3 class="with-lines">Archivos cargados</h3>
          </div>
        </div>
        <div class="row pl-5 pr-5 pb-5">
            <table class="table">
                <thead class="text-center bg-secondary">
                    <tr>
                    <th scope="col">Archivo Cargado</th>
                    <th scope="col">Visor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(result, i) in listDocs" :key="i">
                            <td style="width: 240px;" class="text-center" scope="row">{{result.NombreArchivo}}</td>
                            <td style="width: 120px;" class="text-center">
                                <button @click="mostrarDoc(result.NombreArchivo)" type="button" class="btn btn-primary btn-sm col-7">
                                    <i class="fas fa-eye mr-1"></i>
                                    Ver
                                </button>
                            </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    props: {
      listDocs: Array,
      mostrarDoc: Function,
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$modal.hide('info-individual');
      },
    }
  };
  </script>
  
  <style >
  .bg-secondary{
    background-color: #003c713a !important;
    border-radius: 10px;
  }
  .with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
}
    .btn-blue {
  border-radius: 10px;
  background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
  border: #ffffff;
  color: white;
}

.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 30px !important;
  /* box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4); */
}

.modalContent {
  padding: 15px;
  background-color: white;
  color: white;
  border-radius: 15px;
  position: relative;
  text-align: center;
  border-color: white;
}

.closebtn {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #003c71;
  font-weight: bold;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: #003c718c;
}

.iframe-content {
  width: 100%;
  height: calc(100% - 50px); /* Adjust height to leave space for close button */
  border-color: white;
  border-radius: 0 0 15px 15px; /* Rounded bottom corners */
}

.modal-header {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #003c71;
}

.modal-body {
  padding: 20px;
}
  </style>
  